export enum CustomSource {
  Cra = "Cra",
  SimplifiedCra = "SimplifiedCra",
  Hla = "Hla",
  PlannedTrajectory = "PlannedTrajectory",
  PendingCoordChanges = "PendingCoordChanges",
  CopyNodes = "CopyNodes",
  Surveys = "Surveys",
  StreetView = "StreetView",
  QueryInfrastructure = "QueryInfrastructure",
  ImportHlaOriginDestination = "ImportHlaOriginDestination",
  Parking = "Parking",
  BusStop = "BusStop",
  Mapillary = "Mapillary"
}
